import resume from '../assets/pdf/Sudhanshu_CV.pdf'
// import image from "./Photo_fw14_091.jpg"
import image from './mypic.jpeg'
export const headerData = {
    name: 'Sudhanshu Kumar',
    title: "Full Stack Web Developer",
    desciption:"3+ yrs Experienced full-stack web developer with a flair for creating elegant solutions in the least amount of time. Able to adapt to dynamic environments, also possess team spirit and hunger for learning. ",
    image: image,
    resumePdf: resume
}
